<template>
  <div class="page-container" :class="{ dark: isDarkMode }">
    <!-- 顶部栏 -->
    <header class="page-header" :class="{ dark: isDarkMode }">
      <div class="toggle-theme-btn" :class="{ dark: isDarkMode }" @click="toggleTheme">
        <img :src="darkIcon" alt="">
      </div>
      <div class="logo">
        <img :src="darkLogo" alt="">
      </div>
    </header>

    <!-- 主内容区域 -->
    <main class="main-content">
      <!-- 第一行：五个卡片 -->
      <div class="row row-1">
        <div class="card" :class="{ dark: isDarkMode }">
          <div class="card-title">生产印量</div>
          <div class="border-img"></div>
          <div class="card-label">今日总印量</div>
          <div class="card-value big">
            {{ form.count }}<span class="unit">张</span>
          </div>
          <div class="border"></div>
          <div class="row-desc">
            <div class="card-label">有效印量<br><span>{{ form.okCount }} <span class="unit">张</span></span></div>
            <div class="card-label">过版量<br><span>{{ form.noCount }} <span class="unit">张</span></span></div>
          </div>
        </div>

        <div class="card" :class="{ dark: isDarkMode }">
          <div class="card-title">消息提醒</div>
          <div class="border-img"></div>
          <div
              class="message-item"
              :class="getItemClass(item.type)"
              v-for="(item, index) in form.message"
              :key="index"
          >
            <!-- 动态图标容器 -->
            <div :class="`${getItemClass(item.type)}-img`">
              <img
                  :src="getItemIcon(item.type)"
                  alt=""
              >
            </div>
            <div class="center">
              <div class="flex">
                <span class="msg-tag">{{ getItemTag(item.type) }}</span>
                <span class="msg-time">{{ item.time }}</span>
              </div>
              <div class="msg-desc">{{ item.message }}</div>
            </div>
          </div>
         <!-- <div class="message-item warn">
            <div class="warn-img">
              <img src="@/assets/equipment/wd.png" alt="">
            </div>
            <div class="center">
              <div class="flex">
                <span class="msg-tag">水箱报警</span>
                <span class="msg-time">2025/02/23 02:37</span>
              </div>
              <div class="msg-desc">电导率偏高，需检查</div>
            </div>
          </div>
          <div class="message-item wraing">
            <div class="wraing-img">
              <img src="@/assets/equipment/wraing.png" alt="">
            </div>
            <div class="center">
              <div class="flex">
                <span class="msg-tag">保养超时报警</span>
                <span class="msg-time">2025/09/07 09:10</span>
              </div>
              <div class="msg-desc">印刷单元月保养逾期2小时</div>
            </div>
          </div>
          <div class="message-item wraing2">
            <div class="wraing2-img">
              <img src="@/assets/equipment/waring2.png" alt="">
            </div>
            <div class="center">
              <div class="flex">
                <span class="msg-tag">换型超时提醒</span>
                <span class="msg-time">2025/06/26 02:28</span>
              </div>
              <div class="msg-desc">上次换型用时超出标准15分钟</div>
            </div>
          </div>-->
        </div>

        <div class="card" :class="{ dark: isDarkMode }">
          <div class="card-title">水箱状态</div>
          <div class="border-img"></div>
          <div class="status-item">
            <div>
              <img src="@/assets/equipment/warter.png" alt="">
              <span>水箱温度</span>
            </div>
            <span class="status-value">{{ form.wd }} <span>℃</span></span>

          </div>
          <div class="border"></div>
          <div class="status-item">
            <div>
              <img src="@/assets/equipment/ph.png" alt="">
              <span>PH值</span>
            </div>
            <span class="status-value">{{ form.ph }} &nbsp;&nbsp;</span>
          </div>
          <div class="border"></div>
          <div class="status-item">
            <div>
              <img src="@/assets/equipment/ddl.png" alt="">
              <span>电导率</span>
            </div>
            <span class="status-value">{{ form.ddl }} <span>μS</span></span>
          </div>
        </div>

        <div class="card" :class="{ dark: isDarkMode }">
          <div class="card-title">OEE指标</div>
          <div class="border-img"></div>
          <div class="progress-item progress-item1">
            <span>时间稼动率</span>
            <span class="progress-value">{{ form.timeOee }}<span>%</span></span>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: form.timeOee + '%' }"></div>
            </div>
          </div>
          <div class="border"></div>
          <div class="progress-item progress-item2">
            <span>性能稼动率</span>
            <span class="progress-value">{{ form.chanNengOee }}<span>%</span></span>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: form.chanNengOee + '%' }"></div>
            </div>
          </div>
        </div>

        <div class="card" :class="{ dark: isDarkMode }">
          <div class="card-title">车间状态</div>
          <div class="border-img"></div>
          <div class="status-item">
            <div>
              <img src="@/assets/equipment/warter.png" alt="">
              <span>车间温度</span>
            </div>
            <span class="status-value">{{ form.temperature }}<span>℃</span></span>
          </div>
          <div class="border"></div>
          <div class="status-item">
            <div>
              <img src="@/assets/equipment/sd.png" alt="">
              <span>车间湿度</span>
            </div>
            <span class="status-value">{{ form.humidity }}<span>%</span></span>
          </div>
        </div>
      </div>

      <!-- 第二行：保养项目 + 设备运行详情 -->
      <div class="row row-2">
        <div class="card card-left" :class="{ dark: isDarkMode }">
          <div class="card-title">检查项目</div>
          <div class="border-img2"></div>
          <div class="tabs">
            <span class="tab" :class="{ active: activeTab === 'day' }" @click="activeTab='day'">日保养</span>
            <span class="tab" :class="{ active: activeTab === 'week' }" @click="activeTab='week'">周保养</span>
            <span class="tab" :class="{ active: activeTab === 'month' }" @click="activeTab='month'">月保养</span>
            <span class="tab" :class="{ active: activeTab === 'year' }" @click="activeTab='year'">年保养</span>
          </div>
          <div class="total"><span class="title">项目总数</span> <span class="orange">39<span class="total-number">/42</span></span></div>
          <div class="border"></div>
          <div class="check-grid">
            <div class="check-col">
              <div class="col-title"><span class="title">保养检查项</span> <span class="orange">18<span class="total-number">/21</span></span></div>
              <div class="check-item">印刷单元</div>
              <div class="check-item">压印滚筒牙排 <span class="green">2/2</span></div>
              <div class="check-item">传统滚筒牙排 <span class="orange">2/3</span></div>
              <div class="check-item">递纸滚筒牙排 <span class="green">2/2</span></div>
              <div class="check-item">摆动牙开牙球 <span class="gray">0/2</span></div>
              <div class="check-item">上光单元</div>
              <div class="check-item">光油辊驱动 <span class="green">3/3</span></div>
              <div class="check-item">收纸单元</div>
              <div class="check-item">导纸板 <span class="green">2/2</span></div>
              <div class="check-item">输纸单元</div>
              <div class="check-item">纸堆左右移动调节机构 <span class="green">2/2</span></div>
              <div class="check-item">飞达头传动丝杆 <span class="orange">2/3</span></div>
              <div class="check-item">整体及周边</div>
              <div class="check-item">喷粉机喷头及过滤器 <span class="green">2/2</span></div>
            </div>
            <div class="border-left"></div>
            <div class="check-col">
              <div class="col-title"><span class="title">清洁检查项</span> <span class="green">21<span class="total-number">/21</span></span></div>
              <div class="check-item">印刷单元</div>
              <div class="check-item">拉规吸风滤芯 <span class="green">2/2</span></div>
              <div class="check-item">上光单元</div>
              <div class="check-item">压印滚筒牙排 <span class="green">3/3</span></div>
              <div class="check-item">收纸单元</div>
              <div class="check-item">收纸牙排 <span class="green">2/2</span></div>
              <div class="check-item">输纸单元</div>
              <div class="check-item">飞达阀芯调套 <span class="green">2/2</span></div>
              <div class="check-item">整体及周边</div>
              <div class="check-item">UV/IR灯管 <span class="green">2/2</span></div>
              <div class="check-item">UV/IR控制柜 <span class="green">2/2</span></div>
              <div class="check-item">水箱 <span class="green">2/2</span></div>
              <div class="check-item">酒精箱的冷却系统 <span class="green">2/2</span></div>
              <div class="check-item">风泵油位 <span class="green">2/2</span></div>
              <div class="check-item">风泵滤芯 <span class="green">2/2</span></div>
            </div>
          </div>
        </div>

        <div class="card card-right" :class="{ dark: isDarkMode }">
          <div class="card-title">设备运行详情</div>
          <div class="border-img3"></div>
          <div class="device-info">
            <div class="info-item">设备名称<div>{{ form.name }}</div></div>
            <div class="info-item">设备类型<div>{{ form.deviceType }}-{{ form.printType }}</div></div>
          </div>
          <!-- 设备示意图（用占位表示） -->
          <div class="device-preview">
            <div class="machine-img">
              <img :src="form.url" alt="">
              <!-- 这里可以放设备图片，也可以用背景图替代 -->
            </div>
          </div>
          <div class="chart-title">运行速度趋势</div>
          <div class="chart-area">
            <!-- 图表区域，可接 ECharts -->
            <RunSpeedChart :speed-list="form.speedList || []" />
<!--            <div class="chart-placeholder"></div>-->
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import RunSpeedChart from '@/components/Charts/RunSpeedChart.vue';
import API from '@/api';
export default {
  name: 'DashboardPage',
  components: {
    RunSpeedChart
  },
  data() {
    return {
      isDarkMode: false, // 默认浅色模式
      activeTab: 'month',
      form: {
        speedList:[]
      }
    }
  },
  computed: {
    darkLogo() {
      return this.isDarkMode
          ? require('@/assets/img.png')
          : require('@/assets/logoReport.png')
    },
    darkIcon() {
      return this.isDarkMode
          ? require('@/assets/equipment/yue.png')
          : require('@/assets/equipment/ri.png')
    }
  },
  created(){
    this.DaPingJiTaiNew()
  },
  methods: {
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
    },
    DaPingJiTaiNew() {
      API.getDaPingJiTaiNew({deviceId:'7fdda0ab-af2b-4f19-bd97-a51d1d0a36d3'}).then(res => {
        console.log(res)
        this.form = {
          ...res.message.data,
          // 确保speedList存在，兜底空数组
          speedList: res.message.data.speedList || []
        };
        console.log(this.form.speedList)
      })
    },
    // 根据 type 返回对应的样式类名
    getItemClass(type) {
      if (type === 6) {
        return 'warn'
      } else if (type === 9 || type === 10) {
        return 'wraing2'
      } else {
        return 'wraing'
      }
    },
    // 根据 type 返回对应图标
    getItemIcon(type) {
      if (type === 6) {
        return require('@/assets/equipment/wd.png')
      } else if (type === 9 || type === 10) {
        return require('@/assets/equipment/waring2.png')
      } else {
        return require('@/assets/equipment/wraing.png')
      }
    },
    // 根据 type 返回对应标题文字
    getItemTag(type) {
      if (type === 6) {
        return '水箱报警'
      } else if (type === 9 || type === 10) {
        return '换型超时提醒'
      } else {
        return '保养超时报警'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  height: 100vh;
  background: linear-gradient(180deg, #D9E9F6 7%, #FFFFFF 100%);
  color: #333;
  transition: all 0.3s ease;
  padding: 0;
  overflow-y: auto;

  &.dark {
    background: #484848;
    color: #fff;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(180deg, #C2DBFF 0%, #E1EEF8 0%, #BECFE8 100%);
    backdrop-filter: blur(10px);
    &.dark {
      background: linear-gradient(0deg, #313132 0%, #484848 100%);
      color: #fff;
    }
  }

  .toggle-theme-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    padding: 6px 12px;
    border-radius: 4px;
    border: 1px solid #d0dbe9;
    img{
      width: 15px;
    }
    &:hover {
      background: #d1d5db;
    }
    &.dark {
      border: 1px solid #565656;
    }
    //.dark & {
    //  background: #6e6e6e;
    //  color: #fff;
    //
    //}
  }

  .logo {
    text-align: right;
    font-weight: bold;
    color: #333;
    img{
      width: 100px;
    }
    .dark & {
      color: #fff;
    }
  }

  .main-content {
    padding: 20px;
  }

  .row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
  }

  .row-1 {
    .card {
      flex: 1;
      min-width: 0;    /* 新增 这是核心！*/
      width: 0;        /* 新增 让 flex 真正等分 */
      overflow: hidden;/* 新增 */
    }
  }

  .row-2 {
    .card-left {
      flex: 1;
    }
    .card-right {
      flex: 2;
    }
  }

  .card {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.76) 0%, rgba(241, 248, 255, 0.76) 100%);
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    transition: background 0.3s;

    //.dark & {
    //  background: #2b2b2b;
    //  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    //}
    &.dark {
      background: #505050;
      color: #fff;
    }
    .card-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 3px;
      display: flex;
      align-items: center;
      color: #001D41;
      &::before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 6px;
        background-image: url("~@/assets/equipment/icon-title.png");
        background-size: 100% 100%;  /* 必须加，让图片填满伪元素 */
        background-repeat: no-repeat; /* 防止重复 */
        background-position: center; /* 居中 */
      }
    }

    .border-img {
      background-image: url("~@/assets/equipment/icon-border.png");
      height: 2px;
      width: 100%;
      background-size: 100% 100%;
      margin-bottom: 10px;
    }
    .border-img2 {
      background-image: url("~@/assets/equipment/icon-border.png");
      height: 2px;
      width: 100%;
      background-size: 100% 100%;
      margin-bottom: 10px;
    }
    .border-img3 {
      background-image: url("~@/assets/equipment/icon-border3.png");
      height: 2px;
      width: 100%;
      background-size: 100% 100%;
      margin-bottom: 10px;
    }
    .card-label{
      font-size: 22px;
      color: #555555;
    }

    .card-value {
      font-size: 44px;
      font-weight: bold;
      color: #222222;
      margin-bottom: 20px;
      margin-top: 8px;
      .dark & {
        color: #fff;
      }
      .unit {
        font-size: 16px;
        margin-left: 4px;
        color: #878787;
      }
    }

    .row-desc {
      display: flex;
      flex: 1;
      justify-content: space-between;
      margin-top: 26px;
      span {
        font-size: 40px;
        font-weight: bold;
        display: flex;
        align-items: end;
        color: #222222;
        .unit {
          font-size: 16px;
          margin-left: 4px;
          color: #878787;
          margin-bottom: 5px;
        }
      }
    }

    .message-item {
      padding: 8px;
      border-radius: 4px;
      margin-bottom: 8px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      gap: 10px; /* 替代 margin，更稳定 */

      /* 核心：强制卡片宽度不溢出 */
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
      overflow: hidden;

      .dark & {
        background: #3a3a3a;
      }

      img {
        height: 44px;
        padding: 10px;
        display: block;
      }

      /* 核心：必须加 min-width:0 */
      .center {
        flex: 1;
        width: 100%;
        min-width: 0;
        overflow: hidden;
      }

      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 0;
        overflow: hidden;
      }

      .msg-tag {
        font-size: 16px;
        white-space: nowrap;
      }

      .msg-time {
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        flex-shrink: 0; /* 时间不被挤压 */
      }

      /* 最终生效省略号 */
      .msg-desc {
        font-size: 14px;
        color: #333;
        margin-top: 4px;

        /* 省略号必须三行 + 宽度限制 */
        display: block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .dark & {
          color: #ddd;
        }
      }

      /* 以下三种样式保持不变 */
      &.warn {
        background: #fef5f5;
        .dark & { background: #4a2020; }
        .warn-img{
          background:#ffe8e8;
          border-radius: 6px;
        }
        .msg-tag { color:#B91C38; }
        .msg-time { color:#D66768; }
        .msg-desc { color: #D66768; }
      }

      &.wraing {
        background:#FFFCEF;
        .wraing-img{
          background:#FFF6CD;
          border-radius: 6px;
        }
        .msg-tag { color:#B45309; }
        .msg-time { color:#D9A82E; }
        .msg-desc { color: #D9A82E; }
      }

      &.wraing2{
        background:#E9F0F5;
        border-radius: 6px;
        .wraing2-img {
          background:#f4f8fa;
          border-radius: 6px;
        }
        .msg-tag { color:#334155; }
        .msg-time { color:#64748B; }
        .msg-desc { color: #64748B; }
      }
    }

    .status-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      margin-top: 15px;
      font-size: 22px;
      color: #555555;
      img {
        width: 24px;
        margin-right:8px
      }
      div{
        display: flex;
        align-items: center;
      }
      .status-value {
        font-size: 44px;
        font-weight: bold;
        color: #222222;
        span{
          color: #555555;
          font-size: 20px;
          font-weight:normal;
        }
      }
    }

    .status-item:first-child {
      margin-top: 0px;
    }
    .status-item:last-child {
      margin-bottom: 0px;
    }
    .progress-item {
      font-size: 22px;
      color: #555555;
      margin-bottom: 50px;
      margin-top: 40px;
      .progress-value {
        float: right;
        font-weight: bold;
        font-size: 40px;
        color: #222222;
        span{
          color:#878787;
          font-size: 16px;
        }
      }
      .progress-bar {
        width: 100%;
        height: 4px;
        background: #e5e7eb;
        border-radius: 2px;
        margin-top: 4px;
        overflow: hidden;
        .dark & {
          background: #444;
        }
        .progress-fill {
          height: 100%;
          background: #00c48c;
          border-radius: 2px;
        }
      }
    }

    .progress-item1 {
      margin-top: 20px;
    }

    .progress-item2 {
      margin-bottom: 0px;
    }

    .tabs {
      display: flex;
      gap: 18px;
      margin-bottom: 16px;
      .tab {
        padding: 13px 32px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 22px;
        background: #f0f0f0;
        border: 2px solid transparent;
        .dark & {
          background: #3a3a3a;
        }
        // 日保养：浅绿背景+深绿文字
        &:nth-child(1) {
          background: #E5F7DB;
          color: #589A69;
          border-color: #B9DFA4;
        }
        // 周保养：浅黄背景+橙黄文字
        &:nth-child(2) {
          background: #fff1cc;
          color: #f59e0b;
          border-color: #ffe099;
        }
        // 月保养：浅绿背景+深绿文字（未选中）
        &:nth-child(3) {
          background: #c1f1e1;
          color:  #10B981;
          border-color: #72e2bd;
        }
        // 年保养：浅红背景+深红文字
        &:nth-child(4) {
          background: #F8C9C9;
          color: #E25C5C;
          border-color: #E29999;
        }

        &.active {
          color: #fff;
          border: 4px solid #ffffff; // 中间白边（关键！）
        }
        /* 日保养 选中加深绿 */
        &:nth-child(1).active {
          background: #589A69;
          box-shadow: 0 0 0 2px #589A69;

        }
        /* 周保养 选中加深黄/橙 */
        &:nth-child(2).active {
          background: #F8AF32;
          box-shadow: 0 0 0 2px #F8AF32;
        }
        /* 月保养 选中加深绿 */
        &:nth-child(3).active {
          background: #10B981;
          box-shadow: 0 0 0 2px #10B981;
        }
        /* 年保养 选中加深红 */
        &:nth-child(4).active {
          background: #E25C5C;
          box-shadow: 0 0 0 2px #E25C5C;
        }
        .dark & {
          background: #22c55e;
          color: #fff;
          border-color: #22c55e;
        }
      }
    }

    .total-number {
      color: #555555;
    }
    .total-number2{
      color: #545659;
    }
    .total {
      font-size: 22px;
      margin-bottom: 16px;
      color: #222222;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        &::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          margin-right: 6px;
          margin-bottom: 5px;
          background-image: url("~@/assets/equipment/lilte.png");
          background-size: 100% 100%;  /* 必须加，让图片填满伪元素 */
          background-repeat: no-repeat; /* 防止重复 */
          background-position: center; /* 居中 */
        }
      }
      .orange {
        color: #f59e0b;
        font-weight: bold;
        font-size: 34px;
        span{
          color: #555555;
        }
      }
    }

    .check-grid {
      margin-top: 20px;
      display: flex;
      gap: 35px;
      .border-left {
        border-right: 1px solid #BAD1F1;
      }
      .check-col {
        flex: 1;
        .col-title {
          font-weight: bold;
          margin-bottom: 8px;
          font-size: 18px;
          display: flex;
          justify-content: space-between;
          .title {
            &::before {
              content: '';
              display: inline-block;
              width: 14px;
              height: 18px;
              margin-right: 6px;
              margin-bottom: -2px;
              background-image: url("~@/assets/equipment/icon-title2.png");
              background-size: 100% 100%;  /* 必须加，让图片填满伪元素 */
              background-repeat: no-repeat; /* 防止重复 */
              background-position: center; /* 居中 */
            }
          }
          .green {
            color: #10b981;
            float: right;
            font-size: 28px;
          }
          .orange {
            color: #f59e0b;
            float: right;
            font-size: 28px;
          }
        }

        .check-item {
          font-size: 13px;
          margin-bottom: 4px;
          margin-right: 15px;
          position: relative;

          /* 默认小绿点 */
          &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            margin-right: 14px;
            margin-bottom: 2px;
            background-color: #00AB84;
            vertical-align: middle;
          }

          .green {
            color: #10b981;
            float: right;
          }
          .orange {
            color: #f59e0b;
            float: right;
          }
          .gray {
            color: #999;
            float: right;
          }
        }

        /* 单独写 subtitle，权重最高，不会被覆盖 */
        .check-item.subtitle {
          color: #222222;
          font-size: 15px;
        }
        .check-item.subtitle::before {
          margin-right: 10px;
          width: 8px !important;
          height: 8px !important;
          background: transparent !important;
          background-image: url("~@/assets/equipment/lilte.png") !important;
          background-size: 100% 100% !important;
          background-repeat: no-repeat !important;
          background-position: center !important;
          border-radius: 0 !important;
        }

      }
    }

    .device-info {
      margin-bottom: 16px;
      display: flex;
      gap: 60px;
      color: #595959;
      font-size: 16px;
      .info-item {
        margin-bottom: 4px;
        div{
          color: #333333;
          font-size: 18px;
        }
      }
    }

    .device-preview {
      .machine-img {
        width: 100%;
        //height: 175px;
        //background: url('~@/assets/equipment/device.png') center/contain no-repeat;
        img{
          width: 100%;
        }
        .dark & {
          filter: brightness(0.8);
        }
      }
    }

    .chart-title {
      margin: 16px 0 8px;
      font-weight: bold;
    }

    .chart-area {
      //height: 160px;
      .chart-placeholder {
        width: 100%;
        height: 100%;
        background: #e5e7eb;
        border-radius: 4px;
        .dark & {
          background: #3a3a3a;
        }
      }
    }
  }
  .border {
    border-top: 1px solid #BAD1F1;
    margin-top: 15px;
  }
}
</style>
